<template>
<div class="sidebar">
  <nav class="sidebar-nav">
    <ul class="nav">
      <li class="nav-item">
        <router-link :to="'/dashboard'" class="nav-link"><i class="icon-speedometer"></i> Dashboard</router-link>
        <router-link :to="'/timeline'" class="nav-link"><i class="fa fa-share-alt"></i> Timeline</router-link>
        <router-link tag="li" class="nav-item nav-dropdown" :to="{ path: '/components'}" disabled>
          <div class="nav-link nav-dropdown-toggle" @click="handleClick"><i class="fa fa-id-card-o"></i> Mystique</div>
          <ul class="nav-dropdown-items">
            <li class="nav-item">
              <router-link :to="'/mystique/realms'" class="nav-link" exact><i class="icon-briefcase"></i> Realms</router-link>
              <router-link :to="'/mystique/groups'" class="nav-link" exact><i class="icon-people"></i> Grupo</router-link>
              <router-link :to="'/mystique/users'" class="nav-link" exact><i class="icon-user"></i> Usuários</router-link>
              <router-link :to="'/mystique/audit'" class="nav-link" exact><i class="fa fa-paw"></i> Auditoria</router-link>
            </li>
          </ul>
        </router-link>
        <router-link tag="li" class="nav-item nav-dropdown" :to="{ path: '/components'}" disabled>
          <div class="nav-link nav-dropdown-toggle" @click="handleClick"><i class="fa fa-object-group"></i> Cerebro</div>
          <ul class="nav-dropdown-items">
            <li class="nav-item">
              <router-link :to="'/cerebro/entities'" class="nav-link" exact><i class="fa fa-object-ungroup"></i> Entidades</router-link>
              <router-link :to="'/cerebro/links'" class="nav-link" exact><i class="fa fa fa-link"></i> Links</router-link>
            </li>
          </ul>
        </router-link>
        <router-link tag="li" class="nav-item nav-dropdown" :to="{ path: '/components'}" disabled>
          <div class="nav-link nav-dropdown-toggle" @click="handleClick"><i class="icon-rocket"></i> Rocket</div>
          <ul class="nav-dropdown-items">
            <li class="nav-item">
              <router-link :to="'/rocket/configurations'" class="nav-link" exact><i class="icon-puzzle"></i> Configurações</router-link>
              <router-link :to="'/rocket/webhooks'" class="nav-link" exact><i class="fa fa-globe"></i> Webhooks</router-link>
            </li>
          </ul>
        </router-link>
        <router-link tag="li" class="nav-item nav-dropdown" :to="{ path: '/components'}" disabled>
          <div class="nav-link nav-dropdown-toggle" @click="handleClick"><i class="fa fa-map-o"></i> Beast</div>
          <ul class="nav-dropdown-items">
            <li class="nav-item">
              <router-link :to="'/beast/decisions'" class="nav-link" exact><i class="fa fa-table"></i> Decisions</router-link>
              <router-link :to="'/beast/workflows'" class="nav-link" exact><i class="fa fa-sitemap"></i> Workflows</router-link>
            </li>
          </ul>
        </router-link>
        <router-link tag="li" class="nav-item nav-dropdown" :to="{ path: '/components'}" disabled>
          <div class="nav-link nav-dropdown-toggle" @click="handleClick"><i class="fa fa-cogs"></i> Shaw</div>
          <ul class="nav-dropdown-items">
            <li class="nav-item">
              <router-link :to="'/shaw/events'" class="nav-link" exact><i class="fa fa-bolt"></i> Events</router-link>
            </li>
          </ul>
        </router-link>
      </li>
    </ul>
  </nav>
</div>
</template>
<script>
export default {
  name: 'sidebar',
  methods: {
    handleClick (e) {
      e.preventDefault()
      e.target.parentElement.classList.toggle('open')
    }
  }
}
</script>

<style lang="css">
  .nav-link {
    cursor:pointer;
  }
</style>



// WEBPACK FOOTER //
// Sidebar.vue?55c897c3